import { assert } from '../../../lib/assert-sidecar'
import { chessPieces } from '../chessPieces-sidecar'
import { chessTilemap } from '../chessTilemap-sidecar'

const namespace = 'spyder-tilemap-piece'
export function runSpyder() {
  let tm = chessTilemap.get()

  // Check tilemap to piece links
  for (let j = 0; j < tm.height; j++) {
    for (let i = 0; i < tm.width; i++) {
      let tp = chessTilemap.getUnsafe(i, j)

      if (tp.pieces.length > 0) {
        if (tp.pieces.length > 1) {
          console.warn(namespace, 'two pieces at one square', i, j)
        }
        for (let iPiece = 0; iPiece < tp.pieces.length; iPiece++) {
          let cp = tp.pieces[iPiece]

          assert.t(cp.tile !== null, 'invalid cp -> tile pointer, null')
          assert.t(cp.tile === tp, 'invalid cp -> tile pointer, wrong')
        }
      }
    }
  }

  // Check piece to tilemap links
  let cps = chessPieces.getAll()
  for (let iCp = 0; iCp < cps.length; iCp++) {
    let cp = cps[iCp]

    let tp = chessTilemap.getSafeIJ(cp)

    if (!tp) {
      console.warn(
        namespace,
        'free chess piece',
        cp.id,
        cp.i,
        cp.j,
        cp.team,
        cp.type,
      )
      assert.t(cp.tile === null, 'invalid cp -> tile pointer, free cp')
    } else {
      assert.t(cp.tile !== null, 'invalid cp -> tile pointer, null 2')
      assert.t(cp.tile === tp, 'invalid cp -> tile pointer, wrong 2')
    }
  }
}
